import {PPConfiguration} from '@gongxigames/framework/integrations/pariplay/PPConfiguration';
import {Xhr} from '@gongxigames/framework/slot/fragments/Xhr';
import {PPResponse} from '@gongxigames/framework/integrations/pariplay/response/PPResponse';
import {PPGameClientWrapper} from '@gongxigames/framework/integrations/pariplay/PPGameClientWrapper';
import {ServerMessage} from '@gongxigames/framework/slot/services/logic/ServerMessage';
import {ErrorMessage} from '@gongxigames/framework/slot/services/logic/ErrorMessage';
import {IBrowser, consoleLogger} from '@gongxigames/framework/core';

export class PPRequest<R extends PPResponse> {
    public static readonly SLOW_REQUEST_TIMEOUT: number = 10000;
    public static HEADERS: any = {'Content-type': 'application/x-www-form-urlencoded'};
    protected config: PPConfiguration;
    protected browser: IBrowser;
    protected callback!: Function;
    protected on_error!: Function;
    protected onSlowRequest!: Function;
    protected response!: R;
    protected timeoutID!: number;
    constructor(config: PPConfiguration, browser: IBrowser) {
        this.config = config;
        this.browser = browser;
    }

    public load(callback: Function, onError?: Function, onSlowRequest?: Function): void {
        this.callback = callback;
        this.on_error = onError!;
        this.onSlowRequest = onSlowRequest!;
        this.send();
    }

    protected send(): void {
        this.timeoutID = this.browser.addTimeout(() => {
            this.onSlowRequest && this.onSlowRequest();
        }, PPRequest.SLOW_REQUEST_TIMEOUT);

        Xhr.postWithFields(this.getURL(), this.getParams(), (body: any) => {
            this.browser.removeTimeout(this.timeoutID);
            this.processResponse(body);
        }, PPRequest.HEADERS, this.getRequestCredentials(), this.onError.bind(this));
    }

    protected onError(xhr?: any, isTimeout?: boolean): void {
        this.browser.removeTimeout(this.timeoutID);
        consoleLogger.error(xhr);
        this.on_error && this.on_error(xhr, isTimeout);
    }

    protected getURL(): string {
        return '';
    }

    protected getParams(): string {
        return '';
    }

    protected processResponse(data: any): void {
        if (data) {
            this.callback();
        } else {
            this.on_error && this.on_error();
        }
    }

    protected getRequestCredentials(): any {
        return {
            ClientToken: this.config.ClientToken,
            Rand: Math.round(Math.random() * 100000000)
        };
    }

    public process(wrapper: PPGameClientWrapper, response: ServerMessage): ServerMessage[] {
        return null!;
    }

    public getErrorCode(): number {
        return this.response ? this.response.getErrorCode() : null!;
    }

    public isError(): boolean {
        if(!this.response || !this.response.source || this.getErrorCode() !== 0) {
            return true;
        }

        return false;
    }

    public getRPErrorMessage(): ErrorMessage {
        return this.response && this.response.source ? this.response.source.Status : null;
    }

    public getRPBody(): any {
        return null;
    }

    public getResponse(): R {
        return this.response;
    }
}
